import { useState, useContext } from 'react';
import FileUploader from './FileUploader';
import { AuthContext } from '../App';
import './StowUploader.css';

const StowUploader = () => {
  const { apiBaseUrl, token } = useContext(AuthContext);
  const [uploading, setUploading] = useState(false);
  const [results, setResults] = useState(null);
  const [error, setError] = useState(null);
  const [totalFiles, setTotalFiles] = useState(0);

  const handleFiles = async (e) => {
    const files = Array.from(e.target.files || []);
    if (files.length === 0) return;

    setUploading(true);
    setResults([]);
    setError(null);
    setTotalFiles(files.length);

    const accumulated = [];
    for (let i = 0; i < files.length; i++) {
      const f = files[i];
      const form = new FormData();
      form.append('file', f);

      try {
        const headers = {};
        if (token) {
          headers['Authorization'] = `Bearer ${token}`;
        }

        const resp = await fetch(`${apiBaseUrl}/stow/instances`, {
          method: 'POST',
          body: form,
          headers
        });

        if (!resp.ok) {
          const txt = await resp.text();
          accumulated.push({ file: f.name, status: 'error', message: txt || resp.statusText });
        } else {
          const data = await resp.json();
          if (data && Array.isArray(data.results) && data.results.length > 0) {
            accumulated.push(data.results[0]);
          } else if (data && data.results) {
            accumulated.push(data.results);
          } else {
            accumulated.push({ file: f.name, status: 'unknown', message: 'No result returned' });
          }
        }
      } catch (err) {
        accumulated.push({ file: f.name, status: 'error', message: err.message || String(err) });
      }

      setResults([...accumulated]);
    }

    setUploading(false);
    setTotalFiles(0);
  };

  return (
    <div className="stow-uploader">
      <h2>Upload DICOM Files (STOW)</h2>
      <br/>
      <p>Upload DICOM files; server will save each file securely in S3 storage.</p>
      <br/>

      <FileUploader onFilesSelected={handleFiles} label={uploading ? 'Uploading…' : 'Choose files to upload'} />

      {uploading && <div className="uploading">Uploading...</div>}

      {error && <div className="upload-error">Error: {error}</div>}

      {results && (
        <div className="results">
          <h3>Results</h3>
          {totalFiles > 0 || uploading ? (
            <div className="progress-block">
              <div className="progress-meta">
                {results.length} / {totalFiles || results.length} uploaded
              </div>
              <div className="progress-outer">
                <div className="progress-inner" style={{ width: `${Math.round((results.length / (totalFiles || results.length || 1)) * 100)}%` }} />
              </div>
            </div>
          ) : null}
          <ul>
            {results.map((r, i) => (
              <li key={i}>
                <strong>{r.file}</strong>: <span className={r.status === 'error' ? 'errorText' : ''}>{r.status}</span> {r.sop ? `(${r.sop})` : ''}
                {r.message ? <span className="upload-error"> — {r.message}</span> : null}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default StowUploader;
